import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { DwOrmDataServiceToken, DwOrmDataService, DwMetaDataServiceToken, DwMetaDataService, DwSecurityUserService, DwCacheService, DwEventService, DwMediaRepositoryService, DwModalService, DwQueryResult } from "@devwareapps/devware-cap";
import { SchoolRepositoryService } from "../../schools/services/school-repository.service";
import { DateTimeUtilService } from "../../shared/util/date-time-util.service";
import { AcsWrittenResultEntity, AcsWrittenTestStatusAllItems, AppMetaData, StudentActivityEntity, StudentCourseForContextQueryEntity, StudentEntity } from "../../../meta-data/app-meta-data.service";
import { Observable } from "rxjs";
import { mergeMap } from "rxjs/operators";


@Injectable({ providedIn: 'root' })
export class StudentRepositoryService {

    constructor(@Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        private dwSecurityUserService: DwSecurityUserService,
        private dwCacheService: DwCacheService,
        private dwEventService: DwEventService,
        private dateTimeUtilService: DateTimeUtilService,
        private dwMediaRepository: DwMediaRepositoryService,
        private router: Router,
        private schoolRepositoryService: SchoolRepositoryService,
        private dwModalService: DwModalService,
    ) {
    }

    getAcsWrittenResults(studentCourseId: number): Observable<AcsWrittenResultEntity[]> {
        const query = AppMetaData.AcsWrittenResult.CreateQueryBuilder();

        query.query.FieldSettings.LoadAllLookupDisplayFields = true;
        query.addFilterAnd(f => f.Equal(a => a.StudentCourseId, studentCourseId));
       
        query.addFilterAnd(f => f.InList(a => a.AcsWrittenTestStatusId, [AcsWrittenTestStatusAllItems.Success, AcsWrittenTestStatusAllItems.New, AcsWrittenTestStatusAllItems.Processing]));
        // query.addFilterAnd(f => f.InList(a => a.AcsWrittenTestStatusId, [AcsWrittenTestStatusAllItems.Success]));
        
       //query.addOrderByDesc(f => f.ExamDate);
        query.addOrderByDesc(f => f.ModifiedDateTime);

        return this.dwOrmDataService.executeQuery<AcsWrittenResultEntity>(query);
    }

    loadAcsWrittenResult(acsWrittenResultId: number): Observable<AcsWrittenResultEntity> {
        const query = AppMetaData.AcsWrittenResult.CreateQueryBuilder();

        query.query.FieldSettings.LoadAllLookupDisplayFields = true;
        query.addFilterAnd(f => f.Equal(a => a.AcsWrittenResultId, acsWrittenResultId));
      

        return this.dwOrmDataService.executeQuerySingle<AcsWrittenResultEntity>(query);
    }

    getStudentCourseForContext(studentCourseId: number): Observable<StudentCourseForContextQueryEntity> {

        return AppMetaData.Queries.StudentCourseForContext.CreateQueryBuilderWithMetaData(this.dwMetaDataService)
            .pipe(mergeMap(result => {

                const query = result.queryBuilder;

                query.addFilterAnd(f => f.Equal(a => a.StudentCourseId, studentCourseId));

                return this.dwOrmDataService.executeQuerySingle<StudentCourseForContextQueryEntity>(query);

            }));
    }

    getStudentFromUserId(userId: number): Observable<StudentEntity> {
        const query = AppMetaData.Student.CreateQueryBuilder();

        query.addFilterAnd(f => f.Equal(a => AppMetaData.DwUser.Attributes.UserId, userId));

        return this.dwOrmDataService.executeQuerySingle<StudentEntity>(query);
    }

    getStudentFromUserIdForSchool(userId: number, flightSchoolId: number): Observable<StudentEntity> {
        const query = AppMetaData.Student.CreateQueryBuilder();

        query.query.FieldSettings.LoadAllLookupDisplayFields = true;
        query.addFilterAnd(f => f.Equal(a => AppMetaData.DwUser.Attributes.UserId, userId));
        query.addFilterAnd(f => f.Equal(a => AppMetaData.UserDetail.Attributes.FlightSchoolId, flightSchoolId));
        query.addPrefetch(r => r.DwUser);

        return this.dwOrmDataService.executeQuerySingle<StudentEntity>(query);
    }

    getStudentActivityPage(studentId: number, pageNo: number, pageSize: number, searchTerm?: string): Observable<DwQueryResult<StudentActivityEntity>> {
        const query = AppMetaData.StudentActivity.CreateQueryBuilder();
        const normalizedSearchTerm = (searchTerm || '').trim();

        query.query.FieldSettings.LoadAllLookupDisplayFields = true;
        query.setupPaging(pageNo, pageSize, true);
        query.addRelation(r => r.StudentActivityType);
        query.addPrefetch(r => r.StudentActivityType);
        query.addFilterAnd(f => f.Equal(a => a.StudentId, studentId));

        if (normalizedSearchTerm) {
            query.addFilterAnd(f => f.GroupOr(
                g => g.Contains(a => a.ActivityTitle, normalizedSearchTerm),
                g => g.Contains(a => a.ActivityDetail, normalizedSearchTerm),
                g => g.Contains(a => a.OldValueText, normalizedSearchTerm),
                g => g.Contains(a => a.NewValueText, normalizedSearchTerm),
                g => g.Contains(a => a.ActorDisplayName, normalizedSearchTerm),
                g => g.Contains(a => a.ActorRoleName, normalizedSearchTerm),
                g => g.Contains(a => AppMetaData.StudentActivityType.Attributes.ActivityTypeName, normalizedSearchTerm),
                g => g.Contains(a => AppMetaData.StudentActivityType.Attributes.ActivityTypeKey, normalizedSearchTerm)
            ));
        }

        query.addOrderByDesc(a => a.ActivityDateTime);

        return this.dwOrmDataService.executePagedQuery<StudentActivityEntity>(query);
    }
}
